/** Vant ConfigProvider 主题变量（与 theme-black-gold.scss 保持一致） */
export const vantThemeVars = {
  primaryColor: '#D4AF37',
  textColor: '#F5F0E1',
  textColor2: '#A89870',
  background: '#0A0A0A',
  background2: '#141414',
  borderColor: 'rgba(212, 175, 55, 0.35)',
  tabbarBackground: '#1C1C1C',
  tabbarItemActiveColor: '#F9E076',
  navBarBackground: '#1C1C1C',
  navBarTitleTextColor: '#F5F0E1',
  navBarIconColor: '#D4AF37',
  popupBackground: '#141414',
  overlayBackground: 'rgba(0, 0, 0, 0.75)',
}
